import React from 'react';
import { Select } from 'antd';
import { fetchCarrierWarehouseList } from 'services/sales';

type Props = {
  carrierNum: number;
  channelAccountNum: number;
  onChange?: Function;
  sandbox: number;
};

const CarrierWarehouseSelector = (props: Props) => {
  const { useState } = React;
  const [currentQueryCondition, setCurrentQueryCondition] = useState<StringKAnyVPair>({});
  //const [defaultValue, setDefaultValue] = useState<any>();
  const [inited, setInited] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isMounted, setIsMounted] = useState<boolean>();
  const [options, setOptions] = useState<StringKAnyVPair[]>([]);

  const getDefaultValue = () => {
    // @ts-ignore
    return props.value;
  };

  // eslint-disable-next-line
  const getWarehouseOptions = async (query: StringKAnyVPair) => {
    const pd = {
      carrierNum: query.carrierNum,
      channelAccountNum: query.channelAccountNum,
      sandbox: query.sandbox,
    };
    //console.log('get opts', props, pd);
    isMounted && setIsLoading(true);
    try {
      const ws = await fetchCarrierWarehouseList(pd);

      Array.isArray(ws) && setOptions(ws.map(e => ({
        label: e.name,
        value: e.code,
      })));
    } catch(e) {
    } finally {
      isMounted && setIsLoading(false);
    }
  };

  // eslint-disable-next-line
  const isCurrentQueryConditionChanged = () => {
    return !(currentQueryCondition.carrierNum === props.carrierNum 
            && currentQueryCondition.channelAccountNum === props.channelAccountNum
            && currentQueryCondition.sandbox === props.sandbox);
  };

  // eslint-disable-next-line
  const isQueryConditionMeaningful = (q: StringKAnyVPair) => {
    return q.carrierNum > 0 && q.channelAccountNum > 0;
  };

  const onChange = (val: any) => {
    const wh = options.find(e => e.value === val);

    props.onChange && props.onChange(wh);
  };

  // eslint-disable-next-line
  const recordQueryCondition = (queryConditon: StringKAnyVPair) => {
    setCurrentQueryCondition({
      carrierNum: queryConditon.carrierNum,
      channelAccountNum: queryConditon.channelAccountNum,
      sandbox: queryConditon.sandbox,
    });
  };

  React.useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
    };
  }, []);

  React.useEffect(() => {
    if (isMounted) {
      if (!inited) {
        //checkProps();
        setInited(true);
      }

      if (isCurrentQueryConditionChanged()) {
        const queryConditon = {
          carrierNum: props.carrierNum,
          channelAccountNum: props.channelAccountNum,
          sandbox: props.sandbox,
        };

        recordQueryCondition(queryConditon);
        setOptions([]);
        isQueryConditionMeaningful(queryConditon) && getWarehouseOptions(queryConditon);
      }
    }
  }, [
    currentQueryCondition,
    getWarehouseOptions,
    inited,
    isCurrentQueryConditionChanged,
    isMounted,
    recordQueryCondition,
    props,
  ]);

  return (<>
    <Select
      defaultValue={getDefaultValue()}
      disabled={!isQueryConditionMeaningful(currentQueryCondition)}
      loading={isLoading}
      onChange={onChange}
      optionFilterProp="label"
      options={options}
      showSearch
    />
  </>);
};

export default CarrierWarehouseSelector;
